<template>
  <div>
    <el-row class="layout-page-heading">
      <el-col :span="24">
        <el-breadcrumb separator="/">
          <el-breadcrumb-item>系统用户</el-breadcrumb-item>
          <el-breadcrumb-item>后台用户</el-breadcrumb-item>
        </el-breadcrumb>
      </el-col>
    </el-row>
    <div class="layout-page-box">
      <el-form :inline="true" label-width="80px" label-position="right" class="search-form">
        <el-form-item label="账号">
          <el-input v-model="filters.empno" clearable></el-input>
        </el-form-item>
        <el-form-item label="名称">
          <el-input v-model="filters.name" clearable></el-input>
        </el-form-item>
        <el-form-item label="手机号">
          <el-input v-model="filters.mobile" clearable></el-input>
        </el-form-item>
        <el-form-item label="区域">
          <el-select :disabled="disabled" v-model="filters.cityCode" placeholder="请选择区域" clearable>
            <el-option v-for="item in citys" :key="item.cityCode" :label="item.name" :value="item.cityCode">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item class="checkButton">
          <el-button type="primary" @click="query(1)">查询</el-button>
        </el-form-item>
      </el-form>
      <div class="buttonText">
        <el-button type="primary" @click="add"><i class="fa fa-plus"></i>添加用户</el-button>
      </div>
    </div>
    <div class="layout-page-box">
      <el-table :data="tableData" style="width: 100%">
        <el-table-column prop="empId" label="用户编号"></el-table-column>
        <el-table-column prop="empno" label="账号"></el-table-column>
        <el-table-column prop="userName" label="名称"></el-table-column>
        <el-table-column prop="jurisdictionName" label="角色名称"></el-table-column>
        <el-table-column prop="mobile" label="手机号"></el-table-column>
        <el-table-column prop="systemType" label="系统类型">
          <template slot-scope="scope">
            <div v-for="(item,index) in scope.row.systemType" :key='index'>
              <span v-if="item==1">预约</span>
              <span v-if="item==2">扫码</span>
              <span v-if="item==3">报表</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="cityName" label="区域"></el-table-column>
        <el-table-column align="center" label="操作">
          <template slot-scope="scope">
            <el-button-group>
              <el-button style="margin-right: 10px;" @click="edit(scope.$index, scope.row)" type="primary" size="small">编辑</el-button>
              <!-- <el-button @click="del(scope.$index, scope.row)" type="danger" size="small">删除</el-button> -->
            </el-button-group>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination @size-change="handleSizeChange" @current-change="pageChanged" :current-page="filters.pagination.page" :page-size="filters.pagination.limit" :page-sizes="[10, 20, 30, 50]" layout="total, sizes,prev, pager, next, jumper" :total="filters.pagination.total">
      </el-pagination>
    </div>
    <el-dialog :visible.sync="dialogFormVisible" center class="dialogItem" :close-on-click-modal="false">
      <el-form :model="formData" label-width="120px" :rules="rules">
        <el-form-item label="区域">
          <el-select :disabled="disabled" v-model="formData.cityCode" placeholder="请选择区域" clearable style="width: 90%">
            <el-option v-for="item in citys" :key="item.cityCode" :label="item.name" :value="item.cityCode">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="用户账号" prop="userName">
          <el-input v-model="formData.userName" style="width: 90%"></el-input>
        </el-form-item>
        <el-form-item label="用户密码" prop="password">
          <el-input v-model="formData.password" style="width: 90%"></el-input>
        </el-form-item>
        <el-form-item label="手机号" prop="mobile">
          <el-input v-model="formData.mobile" style="width: 90%" maxlength="11"></el-input>
        </el-form-item>
        <el-form-item label="系统类型">
          <el-select v-model="formData.systemType" style="width: 90%" multiple>
            <el-option v-for="(item,index) in system" :key="index" :label="item.name" :value="item.systemType">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="账户角色">
          <el-select v-model="formData.id" style="width: 90%" @input="testSX">
            <el-option v-for="(item) in roles" :key="item.id" :label="item.jurisdictionName" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="包含员工">
          <el-select default-first-option filterable multiple v-model="formData.subordinate" style="width: 90%" @input="testSX" :filter-method="empMatch">
            <el-option v-for="(item) in lists" :key="item.id" :label="item.userName" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer partFooter">
        <el-button type="danger" @click="closs()">取 消</el-button>
        <el-button type="primary" @click="doAddgoods()">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import pinyin from 'pinyin-match'
export default {
  name: "list",
  data() {
    return {
      lists: [],
      copyLists: [],
      tableData: [],
      filters: {
        pagination: {
          page: 1,
          limit: 10,
          total: 0
        }
      },
      dialogFormVisible: false,
      formData: {},
      roles: [],
      rules: {
        userName: [{
          required: true,
          message: '请输入用户账号',
          trigger: 'blur'
        },],
        password: [{
          required: true,
          message: '请输入用户密码',
          trigger: 'blur'
        },],
        mobile: [{
          required: true,
          message: '请输入用户手机号',
          trigger: 'blur'
        },],
      },
      accountId: '',
      system: [{
        name: '预约',
        systemType: '1'
      },
      {
        name: '扫码',
        systemType: '2'
      }, {
        name: '报表',
        systemType: '3'
      },
      ],
      citys: [
        {
          name: '南通',
          cityCode: 2
        },
        {
          name: '上海',
          cityCode: 1
        },
        {
          name: '北京',
          cityCode: 3
        },
        {
          name: '温州',
          cityCode: 4
        },
      ],
      disabled: false,
      cityCode: Lockr.get('cityCode')
    }
  },
  methods: {
    testSX() {
      this.$forceUpdate()
    },
    pageChanged(page) {
      this.filters.pagination.page = page
      this.refresh()
    },
    handleSizeChange(sizes) {
      this.filters.pagination.limit = sizes
      this.refresh()
    },
    search() {
      this.filters.pagination.page = 1
      this.refresh()
    },
    empMatch(val) {
      if (val) { //val存在
        this.lists = this.copyLists.filter((item) => {
          // 如果直接包含输入值直接返回true
          if (item.userName) {
            if (item.userName.toUpperCase().indexOf(val.toUpperCase()) != -1) {
              return true
            }
            // 输入值拼音d
            return pinyin.match(item.userName, val)
          }
        })
      } else { //val为空时，还原数组
        this.lists = this.copyLists
      }
    },
    refresh() {
      router.push({
        path: this.$route.path,
        query: _.merge({}, this.$route.query, {
          __query: JSON.stringify(this.filters)
        }, {
            random: Math.random()
          })
      })
    },
    add() {
      this.dialogFormVisible = true
      this.accountId = ''
      this.formData = {
        cityCode: this.cityCode
      }
      api.request("personnel/findAllJurisdiction", {}, (res) => {
        this.roles = res.data
      }, (err) => { })
    },
    doAddgoods() {
      let userId = Lockr.get("empId");
      if (!this.accountId) {
        var querys = {
          mobile: this.formData.mobile,
          userId: userId,
          userName: this.formData.userName,
          password: md5(this.formData.password),
          jurisdictionId: this.formData.id,
          jurisdictionName: "",
          systemType: this.formData.systemType.toString(),
          cityCode: this.formData.cityCode,
          subordinate: this.formData.subordinate.toString(),
        }
        this.roles.forEach(ele => {
          if (ele.id == this.formData.id) {
            querys.jurisdictionName = ele.jurisdictionName
          }
        });
        console.log('新增后台用户')
        api.request("personnel/createPersonnel", querys, (res) => {
          if (res.result == true) {
            this.dialogFormVisible = false
            _g.toast("success", "新增成功")
            this.query(this.filters.pagination.page)
          } else {
            _g.toast("error", "新增失败")
            this.query(this.filters.pagination.page)
          }
        }, (err) => { })
      } else {
        var querys = {
          password: md5(this.formData.password),
          userName: this.formData.userName,
          mobile: this.formData.mobile,
          empId: this.formData.empId,
          systemType: this.formData.systemType.toString(),
          jurisdictionId: this.formData.id,
          jurisdictionName: "",
          userId: userId,
          cityCode: this.formData.cityCode,
          subordinate: this.formData.subordinate.toString(),
        }
        this.roles.forEach(ele => {
          if (ele.id == this.formData.id) {
            querys.jurisdictionName = ele.jurisdictionName
          }
        });
        console.log('修改后台用户')
        api.request("personnel/updatePersonnelLogin", querys, (res) => {
          if (res.result == true) {
            this.dialogFormVisible = false
            _g.toast("success", "修改成功")
            this.query(this.filters.pagination.page)
          } else {
            _g.toast("error", "修改失败")
            this.query(this.filters.pagination.page)
          }
        }, (err) => { })
      }

    },
    edit(index, row) {
      this.dialogFormVisible = true
      this.accountId = row.empId
      console.log(row)
      if (typeof (row.systemType) == 'string') {
        row.systemType = row.systemType.split(',')
      }
      this.formData = JSON.parse(JSON.stringify(row))
      this.formData.id = parseInt(this.formData.jurisdictionId)
      if (this.formData.id == NaN || this.formData.id == '' || !this.formData.id) {
        this.formData.id = ''
      }
      this.formData.subordinate = this.formData.subordinate.map(Number)
      api.request("personnel/findAllJurisdiction", {}, (res) => {
        this.roles = res.data
      }, (err) => { })
      this.$forceUpdate()
    },
    query(page) {
      var querys = {
        empno: this.filters.empno,
        name: this.filters.name,
        page: page,
        size: this.filters.pagination.limit,
        moblie: this.filters.mobile,
        cityCode: this.filters.cityCode,
      }
      api.requestQuiet("personnel/findPersonnelPageList", querys, (res) => {
        this.tableData = res.data.list
        this.filters.pagination.total = res.data.total
        // 查询所有账号接口
        api.request("personnel/findEmployeeInfoAll", {}, (res) => {
          this.copyLists = res.data
          this.lists = res.data
        }, (err) => { })
      }, (err) => { })

    },
    closs() {
      this.dialogFormVisible = false
      this.formData = {}
    },
  },
  created() {
    if (this.cityCode && this.cityCode != 'null') {
      this.filters.cityCode = Lockr.get("cityCode")
      this.disabled = true
    } else {
      this.disabled = false
    }
    this.query(this.filters.pagination.page)
  },
  watch: {
    '$route'(to, from) {
      this.query(this.filters.pagination.page)
    }
  }
}
</script>

<style scoped>
</style>